import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const AllOrdersDialog = (props) => {
  const { openYear, handleOpenYearDialog, columns, tableData, exportCsv } =
    props;
  return (
    <div>
      <Dialog
        open={openYear}
        onClose={handleOpenYearDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth
        CloseOnEscape="true"
      >
        <DialogTitle id="alert-dialog-title">{"Select Year"}</DialogTitle>
        <DialogContent>
          <List>
            <ListItem className="cursor-pointer"
              onClick={() =>
                exportCsv(columns, tableData, new Date().getFullYear())
              }
            >
              <ListItemText primary={new Date().getFullYear()} />
            </ListItem>
            <ListItem className="cursor-pointer"
              onClick={() =>
                exportCsv(columns, tableData, new Date().getFullYear() - 1)
              }
            >
              <ListItemText primary={new Date().getFullYear() - 1} />
            </ListItem>
            <ListItem className="cursor-pointer"
              onClick={() =>
                exportCsv(columns, tableData, new Date().getFullYear() - 2)
              }
            >
              <ListItemText primary={new Date().getFullYear() - 2} />
            </ListItem>
          </List>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AllOrdersDialog;
